import textServices from "services/text-services"

const RankingDescription = () => {
  return (
    <div className='ranking__description'>
      <p>
        {textServices.findByText('ranking/description', 'Este es el ranking de puntos, aquí verás a los demás participantes y en qué posición te encuentras.')}
      </p>
    </div>
  )
}

export default RankingDescription